<div *ngIf="openUploadDetails == _commonservice.Enums.LOADER_SKELETON "
  class="sm:flex block justify-between items-center w-full">
  <div class="sm:flex block gap-3 items-center my-4 sm:my-0">
    <ngx-skeleton-loader [theme]="{
          width: '3.6rem',
          height: '3.6rem',
          margin: '0px'
        }"></ngx-skeleton-loader>
    <div>
      <ngx-skeleton-loader [theme]="{
              width: '190px',
              'border-radius': '0',
              height: '25px',
              margin: '0px'
            }"></ngx-skeleton-loader>
      <ngx-skeleton-loader [theme]="{
                width: '190px',
                'border-radius': '0',
                height: '25px',
                margin: '0px'
              }"></ngx-skeleton-loader>
    </div>
  </div>
  <div class="flex gap-4 my-4 sm:my-0">
    <ngx-skeleton-loader [theme]="{
            width: '80px',
            'border-radius': '10px',  
            height: '3.6rem',  
            margin: '0px'        
          }"></ngx-skeleton-loader>
    <ngx-skeleton-loader *ngIf="!currentUrl" [theme]="{
          width: '80px',
          'border-radius': '10px',          
          height: '3.6rem',
          margin: '0px'
        }"></ngx-skeleton-loader>
  </div>
</div>

<div *ngIf="openUploadDetails == _commonservice.Enums.PROFILE_DETAILS_SKELETON "
  class="sm:flex block justify-between items-center w-full">
  <div class="sm:flex block gap-3 items-center my-4 sm:my-0">
    <ngx-skeleton-loader [theme]="{
          width: '3.6rem',
          height: '3.6rem',
          margin: '0px'
        }"></ngx-skeleton-loader>
    <div>
      <ngx-skeleton-loader [theme]="{
              width: '180px',
              'border-radius': '0',
              height: '25px',
              margin: '0px'
            }"></ngx-skeleton-loader>
      <ngx-skeleton-loader [theme]="{
                width: '180px',
                'border-radius': '0',
                height: '25px',
                margin: '0px'
              }"></ngx-skeleton-loader>
    </div>
  </div>
  <div class="flex gap-4 my-4 sm:my-0">
    <ngx-skeleton-loader [theme]="{
            width: '80px',
            'border-radius': '10px',  
            height: '3.6rem',  
            margin: '0px'        
          }"></ngx-skeleton-loader>

  </div>
</div>